module.exports = __webpack_public_path__ + "static/media/joyable6.acf24565.jpg";